(() => {
  const config = document.getElementById('AbdeenCurrencyConfig');
  if (!config || config.dataset.base !== 'JOD') return;
  const ar = document.documentElement.lang.startsWith('ar');
  const rate = Number(config.dataset.jodPerUsd);
  if (!(rate > 0)) return;
  const key = 'abdeen-display-currency';
  let selected = 'JOD';
  try { if (localStorage.getItem(key) === 'USD') selected = 'USD'; } catch {}
  const originals = new WeakMap();
  const pattern = /(\d[\d,]*(?:\.\d+)?)\s*(?:JOD|JD|د\.ا|دأ)(?![\w])/g;
  const skip = 'script,style,noscript,textarea,option,[contenteditable],.rte,.product__description,.ab-currency-ui,price-range,facet-filters-form,.facets,.mobile-facets';
  const observer = new MutationObserver(records => {
    observer.disconnect();
    for (const record of records) {
      if (record.type === 'characterData') convert(record.target);
      for (const node of record.addedNodes) scan(node);
    }
    observe();
  });
  function convert(node) {
    if (!node.parentElement || node.parentElement.closest(skip)) return;
    const previous = originals.get(node);
    const raw = previous && node.nodeValue === previous.rendered ? previous.raw : node.nodeValue;
    pattern.lastIndex = 0;
    if (!pattern.test(raw)) return;
    pattern.lastIndex = 0;
    const rendered = raw.replace(pattern, (match, amount) => {
      const value = Number(amount.replaceAll(',', ''));
      if (!Number.isFinite(value)) return match;
      if (selected === 'USD') return '\u2066≈ ' + new Intl.NumberFormat('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(value / rate) + ' USD\u2069';
      return '\u2066' + amount + ' ' + 'JOD' + '\u2069';
    });
    originals.set(node, {raw, rendered});
    if (node.nodeValue !== rendered) node.nodeValue = rendered;
  }
  function scan(root) {
    if (root.nodeType === Node.TEXT_NODE) { convert(root); return; }
    if (root.nodeType !== Node.ELEMENT_NODE || root.closest(skip)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    while (walker.nextNode()) convert(walker.currentNode);
  }
  function observe() { observer.observe(document.body, {subtree: true, childList: true, characterData: true}); }
  function render() {
    observer.disconnect();
    document.querySelectorAll('[data-ab-currency-select]').forEach(el => { el.value = selected; el.disabled = false; });
    document.querySelectorAll('[data-ab-currency-note]').forEach(el => { el.hidden = selected !== 'USD'; });
    scan(document.body);
    observe();
  }
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-ab-currency-select]')) return;
    selected = event.target.value === 'USD' ? 'USD' : 'JOD';
    try { localStorage.setItem(key, selected); } catch {}
    render();
  });
  window.addEventListener('pageshow', render);
  document.addEventListener('shopify:section:load', render);
  render();
})();
